import {usePoisIsochroneContext} from "poi/map";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ToggleButton from "@mui/material/ToggleButton";
import Stack from "@mui/material/Stack";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import Typography from "@mui/material/Typography";
import Badge from "@mui/material/Badge";
import {theme} from "Theme";
import {useMapContext} from "base/map";

const options = [
    {label: "15 min", value: "15"}, // values present in urls should be strings
    {label: "30 min", value: "30"},
    {label: "1 h", value: "60"},
];

const IsocronasMapTravelTimeAction = () => {
    const {
        selectedTravelTime: selectedOption,
        setSelectedTravelTime: setSelectedOption,
        selectedTransport,
    } = usePoisIsochroneContext();
    const {selectedPoint} = useMapContext();

    const handleOption = (event, value) => {
        setSelectedOption(value);
    };

    return (
        <Stack
            justifyContent="flex-start"
            alignItems="center"
            direction="row"
            spacing={1}
        >
            <Typography variant="caption" sx={{fontSize: 10, whiteSpace: "wrap"}}>
                Tiempo
            </Typography>
            <ToggleButtonGroup
                value={selectedOption}
                exclusive
                onChange={handleOption}
                aria-label="selector de tiempo"
                size="small"
                sx={{flex: 1}}
            >
                {options.map(option => (
                    <ToggleButton
                        key={option.value}
                        value={option.value}
                        aria-label={`${option.value} minutos`}
                        sx={{
                            color:
                                selectedPoint && !selectedOption
                                    ? theme.palette.warning.light
                                    : "inherit",
                            backgroundColor: "white",
                            "&.Mui-selected": {
                                backgroundColor: "#2e85cb",
                                color: "white",
                                "&:hover": {
                                    backgroundColor: "#2e85ee",
                                },
                            },
                            "&.MuiToggleButtonGroup-middleButton, &.MuiToggleButtonGroup-lastButton":
                                {
                                    borderLeft: "1px solid lightgrey",
                                },
                        }}
                    >
                        <Stack>
                            <Typography fontSize={12} lineHeight={1}>
                                {option.value}
                            </Typography>
                            <Typography
                                variant="body1"
                                fontSize={8}
                                textTransform="lowercase"
                                lineHeight={1}
                            >
                                mins
                            </Typography>
                        </Stack>
                    </ToggleButton>
                ))}
            </ToggleButtonGroup>
        </Stack>
    );
};

export default IsocronasMapTravelTimeAction;
